import { EmailTemplate } from "../../types/features/administration/EmailTemplate";
import { TemplateDefault } from "./TemplateDefault";
import { TemplateSimple } from "./TemplateSimple";

export const templatesList: EmailTemplate[] = [TemplateDefault, TemplateSimple];
